import React, { Component } from 'react'

import ReactTable from "react-table"
import 'react-table/react-table.css'

import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'

import moment from 'moment'
import _ from 'lodash'
import requester from '../../../lib/requester'

class SummaryApproval extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      user: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getSummaryApproval()
  }

  getSummaryApproval = () => {
    let url = '/api/traces_chd/v1/assignment/data-summary-assignment-all'
    let param = {
      branch: this.state.user.branch
    }
    this.setState({ loading: true })
    requester.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ loading: false, dataTable: data })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }
  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'SKP NO',
          accessor: 'skp_number',
          filterable: true
        },
        {
          Header: 'PROGRAM NO',
          accessor: 'program_number',
          filterable: true
        },
        {
          Header: 'REF NO',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_name',
          filterable: true
        },
        {
          Header: 'PROGRAM DESCRIPTION',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'CUSTOMER NAME',
          accessor: 'customer_name',
          filterable: true
        },
        {
          Header: 'PACKAGE',
          accessor: 'package',
          filterable: true
        },
        {
          Header: 'SUBMITTED DATE',
          accessor: 'creation_date',
          className: 'text-right',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          ),
          filterable: true
        },
        {
          Header: 'DOWNLOAD SKP',
          accessor: 'program_customer_id',
          Cell: function(row) {
            if (row.original.program_name === 'BIDAN' || row.original.program_name === 'PEGASUS' || row.original.program_name === 'BRANDING RELASI') {
              return (
                <span>
                  <button className="btn btn-success btn-block btn-sm" onClick={() => { app.downloadSKP(row) }}><i className="fa fa-download" /> Download</button>
                </span>
              )
            } else {
              return <span></span>
            }
          }
        },
        {
          Header: 'UPLOAD SKP',
          accessor: 'program_customer_id',
          Cell: function(row) {
            if (row.original.program_name === 'BIDAN' || row.original.program_name === 'PEGASUS' || row.original.program_name === 'BRANDING RELASI') {
              return (
                <span>
                  <button className="btn btn-warning btn-block btn-sm" onClick={() => { app.uploadSKP(row) }}><i className="fa fa-upload" /> Upload</button>
                </span>
              )
            } else {
              return <span></span>
            }
          }
        },
        {
          Header: '',
          accessor: 'program_customer_id',
          Cell: row => (
            <span>
              <button className="btn btn-info btn-sm" onClick={() => { this.goDetail(row) }}><i className="fa fa-eye" /> View</button>
            </span>
          )
        }
      ],
      rows: this.state.dataTable

    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = row[filter.id]
        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  uploadSKP = (row) => {
    this.props.history.push('/admin/assignment-chd/upload-doc/' + row.value)
  }

  downloadSKP = (row) => {
    let url = '/api/traces_chd/v1/assignment/doc?id=' + (row.value || 0)
    this.setState({ loading: true })
    requester.getCHD(url, {
      success: function(response) {
        let {data} = response.data
        this.setState({ loading: false })

        if (data.fullpath) {
          window.open(data.fullpath, '_blank')
        }
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  goDetail = (rows) => {
    let { original } = rows
    this.props.history.push('/admin/assignment-chd/assignment-detail/' + rows.value + '?pid=' + original.program_id)
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default SummaryApproval